import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ReactDatePicker = ({selectedDate, onChange, minDate, maxDate, showYearDropdown = true, showMonthDropdown = true}) => {

  const handleRawChange = (e) => {
    const value = e.target.value;
    const regex = /^\d{4}-\d{2}-\d{2}$/; // Match yyyy-MM-dd format
    if (!regex.test(value)) {
      // alert("Invalid date format! Use yyyy-MM-dd");
    }
  };

  // Convert string date to Date object if needed
  const getDateObject = (date) => {
    if (!date) return null;
    if (date instanceof Date) return date;
    // If it's a string, convert to Date
    return new Date(date);
  };

  // Custom header to show only dropdowns without duplicate text
  const renderCustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 100; i <= currentYear + 10; i++) {
      years.push(i);
    }

    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: '0 10px',
        marginBottom: '5px'
      }}>
        <button 
          onClick={decreaseMonth} 
          disabled={prevMonthButtonDisabled}
          type="button"
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            padding: '5px'
          }}
        >
          {"<"}
        </button>
        
        <div style={{ display: 'flex', gap: '5px' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <select
              value={months[date.getMonth()]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
              style={{
                padding: '3px 20px 3px 5px',
                fontSize: '13px',
                border: '1px solid #ccc',
                borderRadius: '3px',
                appearance: 'none',
                WebkitAppearance: 'none',
                MozAppearance: 'none',
                background: 'white',
                cursor: 'pointer'
              }}
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <span style={{
              position: 'absolute',
              right: '5px',
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              fontSize: '10px',
              color: '#666'
            }}>▼</span>
          </div>

          <div style={{ position: 'relative', display: 'inline-block' }}>
            <select
              value={date.getFullYear()}
              onChange={({ target: { value } }) => changeYear(parseInt(value))}
              style={{
                padding: '3px 20px 3px 5px',
                fontSize: '13px',
                border: '1px solid #ccc',
                borderRadius: '3px',
                appearance: 'none',
                WebkitAppearance: 'none',
                MozAppearance: 'none',
                background: 'white',
                cursor: 'pointer'
              }}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <span style={{
              position: 'absolute',
              right: '5px',
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              fontSize: '10px',
              color: '#666'
            }}>▼</span>
          </div>
        </div>

        <button 
          onClick={increaseMonth} 
          disabled={nextMonthButtonDisabled}
          type="button"
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            padding: '5px'
          }}
        >
          {">"}
        </button>
      </div>
    );
  };

  return (
    <DatePicker 
      selected={getDateObject(selectedDate)} 
      onChange={(date) => onChange(date)} 
      dateFormat="yyyy-MM-dd"
      onChangeRaw={handleRawChange}
      minDate={minDate}
      maxDate={maxDate}
      renderCustomHeader={renderCustomHeader}
    />
  );
};

export default ReactDatePicker;
